import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GridService } from '../shared/grid/grid.service';
import { GridView } from '../models/gridView.model';
import { UserViewLookup } from '../models/userView.model';

@Injectable({
  providedIn: 'root',
})
export class GridViewService extends GridService<GridView> {
  constructor(http: HttpClient) {
    super('GridView', http);
  }

  getDefaultView(gridId: string): Observable<GridView | null> {
    const params = new HttpParams().set('gridId', gridId);
    return this.http.get<GridView>(this.getApiUrl('GridView/GetDefaultView'), { params });
  }

  override getAll(filterBy?: string): Observable<UserViewLookup[]> {
    let filter: Record<string, unknown> = {};
    if (filterBy) {
      try { filter = JSON.parse(filterBy); } catch { filter = {}; }
    }
    filter.isMobileView ??= false;
    return this.http.get<UserViewLookup[]>(this.getApiUrl('GridView/GetAll'), {
      params: { filterBy: JSON.stringify(filter) }
    });
  }
}
